import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconCard.module.css';

const BRAND_AMEX = 'amex';
const BRAND_DINERS = 'diners';
const BRAND_DISCOVERY = 'discovery';
const BRAND_JCB = 'jcb';
const BRAND_MASTERCARD = 'mastercard';
const BRAND_UNIONPAY = 'unionpay';
const BRAND_VISA = 'visa';
const SEARCH = 'search';
const TRASH = 'trash';
const PLUS = 'plus';
const USER = 'user';
const LOCATION = 'location';
const CANCEL = 'cancel';
const MAIL = 'mail';
const MESSAGE = 'message';
const ROUNDCHECK = 'roundcheck';
const PEOPLE = 'people';
const STAR = 'star';
const PEOPLES = 'peoples';
const BLANKSTAR = 'blankstar';
const LOCATIONCARD = 'locationcard';
const CARDSTAR = 'cardstar';
const FILLHEART = 'like';
const BLANKHEART = 'dislike';
const SHARE = 'share';
const COPY = 'copy';
const WHATSAPP = 'whatsapp';
const FAVLIKE = 'favlike';
const CROSS = 'cross';
const CLOCK = 'clock';
const HALFSTAR = 'halfstar';
const GARDEN = 'garden';
const POOL = 'pool';
const INDOOR = 'interiores';

const IconCard = props => {
  const { className, rootClassName, brand } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (brand) {
    case INDOOR:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path d="m16.532 2.502 8.198 7.173h2.682V10.8h-2.25v16.875h2.25V28.8H3.788v-1.125h2.25V10.8L6.036 10.8H3.788v-1.125h2.78l9.249 -7.194 0.366 -0.286zM7.163 27.675h2.25V16.032h3.768v3.036H10.2v8.607h3.713v-6.75h7.875v6.75h2.25V10.8H7.162zm7.875 0h2.25V22.05h-2.25zm2.925 0h2.7V22.05h-2.7zM10.2 18.282h2.194v-1.464H10.2zm-1.801 -8.607h14.623L16.141 3.653zm15.738 -2.996a0.27 0.27 0 0 1 0.322 0.206l0.168 0.776a0.271 0.271 0 0 1 -0.528 0.115l-0.168 -0.776a0.27 0.27 0 0 1 0.206 -0.321m-1.746 -0.17c0.197 -0.295 0.641 -0.009 0.454 0.293l-0.274 0.425a0.27 0.27 0 0 1 -0.454 -0.293zm2.896 -0.625a0.27 0.27 0 0 1 0.374 -0.08l0.425 0.274c0.227 0.135 0.111 0.507 -0.148 0.497 -0.118 0.017 -0.469 -0.266 -0.57 -0.318a0.27 0.27 0 0 1 -0.082 -0.373M23.43 3.395c1.999 -0.358 2.615 2.503 0.647 2.998 -0.798 0.192 -1.666 -0.366 -1.822 -1.175 -0.19 -0.803 0.366 -1.666 1.175 -1.823m1.294 1.289c-0.168 -0.856 -1.355 -1.063 -1.805 -0.328 -0.298 0.442 -0.158 1.093 0.296 1.373 0.73 0.48 1.703 -0.193 1.509 -1.045m-3.076 0.388c0.348 -0.07 0.46 0.448 0.114 0.528 -0.019 0.002 -0.848 0.191 -0.833 0.174h-0.001c-0.316 0.004 -0.369 -0.468 -0.057 -0.534zM26.52 4.02c0.348 -0.069 0.459 0.447 0.114 0.528l-0.776 0.168a0.27 0.27 0 0 1 -0.114 -0.528zm-5.099 -0.308c-0.295 -0.197 -0.008 -0.642 0.293 -0.454l0.425 0.274c0.226 0.135 0.112 0.506 -0.147 0.497 -0.118 0.017 -0.469 -0.266 -0.57 -0.317m3.514 -1.149a0.27 0.27 0 0 1 0.454 0.292l-0.274 0.425a0.27 0.27 0 0 1 -0.454 -0.292zm-1.848 -0.757a0.27 0.27 0 0 1 0.32 0.208l0.167 0.776c0.065 0.325 -0.384 0.446 -0.508 0.174l-0.02 -0.06 -0.167 -0.777a0.27 0.27 0 0 1 0.208 -0.321" />
        </svg>
      );
    case POOL:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          zoomAndPan="magnify"
          viewBox="0 0 75 74.999997"
          height="100"
          preserveAspectRatio="xMidYMid meet"
          version="1.0"
        >
          <defs>
            <clipPath id="278bbcdcf2">
              <path
                d="M 25.875 30.375 L 29.699219 30.375 L 29.699219 34.199219 L 25.875 34.199219 Z M 25.875 30.375 "
                clipRule="nonzero"
              />
            </clipPath>
            <clipPath id="c4fa926acb">
              <path
                d="M 27.789062 30.375 C 26.730469 30.375 25.875 31.230469 25.875 32.289062 C 25.875 33.34375 26.730469 34.199219 27.789062 34.199219 C 28.84375 34.199219 29.699219 33.34375 29.699219 32.289062 C 29.699219 31.230469 28.84375 30.375 27.789062 30.375 Z M 27.789062 30.375 "
                clipRule="nonzero"
              />
            </clipPath>
          </defs>
          <path
            fill="#ffffff"
            d="M 28.011719 51.160156 C 26.425781 51.160156 25.136719 49.871094 25.136719 48.285156 L 25.136719 12.40625 C 25.136719 12.332031 25.140625 12.257812 25.148438 12.183594 C 25.207031 11.285156 25.050781 8.574219 23.628906 7.054688 C 22.8125 6.179688 21.617188 5.753906 19.972656 5.753906 C 18.445312 5.753906 16.386719 6.003906 15.261719 7.179688 C 14.378906 8.101562 14.359375 9.289062 14.359375 9.296875 C 14.433594 10.882812 13.203125 12.230469 11.617188 12.300781 C 10.039062 12.371094 8.6875 11.144531 8.617188 9.558594 C 8.597656 9.195312 8.527344 5.90625 11.105469 3.210938 C 13.136719 1.082031 16.121094 0.00390625 19.972656 0.00390625 C 24.078125 0.00390625 26.53125 1.722656 27.867188 3.167969 C 31.054688 6.609375 30.945312 11.503906 30.886719 12.503906 L 30.886719 48.285156 C 30.886719 49.871094 29.601562 51.160156 28.011719 51.160156 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 56.566406 50.484375 C 54.980469 50.484375 53.722656 49.871094 53.722656 48.285156 L 53.722656 12.40625 C 53.722656 12.332031 53.722656 12.257812 53.730469 12.183594 C 53.789062 11.285156 53.636719 8.574219 52.214844 7.054688 C 51.394531 6.179688 50.199219 5.753906 48.554688 5.753906 C 47.027344 5.753906 44.972656 6.003906 43.84375 7.179688 C 42.964844 8.101562 42.941406 9.289062 42.945312 9.296875 C 43.015625 10.882812 41.789062 12.230469 40.203125 12.300781 C 38.621094 12.371094 37.273438 11.144531 37.199219 9.558594 C 37.183594 9.195312 37.113281 5.90625 39.6875 3.210938 C 41.71875 1.082031 44.703125 0.00390625 48.554688 0.00390625 C 52.664062 0.00390625 55.117188 1.722656 56.449219 3.167969 C 59.636719 6.609375 59.53125 11.503906 59.472656 12.503906 L 59.472656 48.285156 C 59.472656 49.871094 58.15625 50.484375 56.566406 50.484375 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 56.59375 49.820312 C 55.007812 49.820312 53.71875 48.53125 53.71875 46.945312 L 53.71875 12.40625 C 53.71875 12.332031 53.722656 12.257812 53.730469 12.183594 C 53.789062 11.285156 53.632812 8.574219 52.214844 7.054688 C 51.394531 6.179688 50.199219 5.753906 48.558594 5.753906 C 46.402344 5.753906 44.789062 6.230469 43.890625 7.132812 C 42.953125 8.074219 42.945312 9.300781 42.945312 9.351562 L 40.074219 9.429688 L 37.203125 9.5625 C 37.183594 9.195312 37.113281 5.90625 39.6875 3.210938 C 41.71875 1.082031 44.703125 0.00390625 48.558594 0.00390625 C 52.664062 0.00390625 55.113281 1.722656 56.449219 3.164062 C 59.636719 6.609375 59.527344 11.503906 59.46875 12.503906 L 59.46875 46.945312 C 59.46875 48.53125 58.183594 49.820312 56.59375 49.820312 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 56.59375 19.152344 L 28.011719 19.152344 C 26.425781 19.152344 25.136719 17.863281 25.136719 16.277344 C 25.136719 14.6875 26.425781 13.402344 28.011719 13.402344 L 56.59375 13.402344 C 58.183594 13.402344 59.46875 14.6875 59.46875 16.277344 C 59.46875 17.863281 58.183594 19.152344 56.59375 19.152344 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 56.59375 37.613281 L 28.011719 37.613281 C 26.425781 37.613281 25.136719 36.324219 25.136719 34.738281 C 25.136719 33.152344 26.425781 31.863281 28.011719 31.863281 L 56.59375 31.863281 C 58.183594 31.863281 59.46875 33.152344 59.46875 34.738281 C 59.46875 36.324219 58.183594 37.613281 56.59375 37.613281 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 31.648438 51.894531 C 25.269531 51.894531 19.878906 48.984375 18.054688 47.871094 C 8.804688 51.191406 1.375 47.570312 1.054688 47.410156 C 0.34375 47.054688 0.0585938 46.191406 0.414062 45.480469 C 0.769531 44.773438 1.628906 44.484375 2.339844 44.835938 C 2.445312 44.890625 9.386719 48.207031 17.691406 44.9375 C 18.144531 44.757812 18.65625 44.820312 19.050781 45.101562 C 19.570312 45.464844 31.988281 53.996094 42.59375 44.886719 C 43.03125 44.507812 43.65625 44.433594 44.171875 44.691406 C 44.3125 44.761719 58.339844 51.59375 72.734375 45.398438 C 73.460938 45.085938 74.308594 45.421875 74.621094 46.152344 C 74.9375 46.882812 74.597656 47.726562 73.871094 48.039062 C 60.167969 53.9375 47.183594 49.152344 43.746094 47.660156 C 39.730469 50.828125 35.507812 51.894531 31.648438 51.894531 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 54.394531 63.425781 C 49.132812 63.425781 44.460938 61.320312 42.648438 60.386719 C 31.980469 66.753906 21.714844 60.214844 21.273438 59.929688 C 20.609375 59.496094 20.421875 58.605469 20.855469 57.941406 C 21.285156 57.273438 22.175781 57.085938 22.839844 57.519531 C 23.230469 57.769531 32.480469 63.609375 41.816406 57.519531 C 42.273438 57.222656 42.859375 57.207031 43.332031 57.488281 C 43.445312 57.554688 54.945312 64.171875 62.980469 57.609375 C 63.59375 57.109375 64.5 57.199219 65 57.816406 C 65.503906 58.429688 65.410156 59.335938 64.796875 59.839844 C 61.5 62.53125 57.820312 63.425781 54.394531 63.425781 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <g clipPath="url(#278bbcdcf2)">
            <g clipPath="url(#c4fa926acb)">
              <path
                fill="#ffffff"
                d="M 25.875 30.375 L 29.699219 30.375 L 29.699219 34.199219 L 25.875 34.199219 Z M 25.875 30.375 "
                fillOpacity="1"
                fillRule="nonzero"
              />
            </g>
          </g>
        </svg>
      );
    case GARDEN:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          zoomAndPan="magnify"
          viewBox="0 0 75 74.999997"
          height="100"
          preserveAspectRatio="xMidYMid meet"
          version="1.0"
        >
          <defs>
            <clipPath id="dc0677f197">
              <path
                d="M 4 2.617188 L 37 2.617188 L 37 38 L 4 38 Z M 4 2.617188 "
                clipRule="nonzero"
              />
            </clipPath>
            <clipPath id="d39ab2ec3c">
              <path
                d="M 58 20 L 61 20 L 61 61.867188 L 58 61.867188 Z M 58 20 "
                clipRule="nonzero"
              />
            </clipPath>
            <clipPath id="5944c24418">
              <path d="M 4 46 L 33 46 L 33 61.867188 L 4 61.867188 Z M 4 46 " clipRule="nonzero" />
            </clipPath>
            <clipPath id="3d728003be">
              <path
                d="M 24 42 L 57 42 L 57 61.867188 L 24 61.867188 Z M 24 42 "
                clipRule="nonzero"
              />
            </clipPath>
            <clipPath id="aa839afb10">
              <path d="M 0 60 L 67 60 L 67 61.867188 L 0 61.867188 Z M 0 60 " clipRule="nonzero" />
            </clipPath>
            <clipPath id="66e2abaf46">
              <path
                d="M 27.523438 53.296875 L 29.398438 53.296875 L 29.398438 55.214844 L 27.523438 55.214844 Z M 27.523438 53.296875 "
                clipRule="nonzero"
              />
            </clipPath>
            <clipPath id="648f915682">
              <path
                d="M 28.460938 53.296875 C 27.945312 53.296875 27.523438 53.726562 27.523438 54.253906 C 27.523438 54.78125 27.945312 55.210938 28.460938 55.210938 C 28.980469 55.210938 29.398438 54.78125 29.398438 54.253906 C 29.398438 53.726562 28.980469 53.296875 28.460938 53.296875 Z M 28.460938 53.296875 "
                clipRule="nonzero"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#dc0677f197)">
            <path
              fill="#ffffff"
              d="M 19.183594 37.851562 C 15.40625 37.851562 12.332031 34.777344 12.332031 31 C 12.332031 30.832031 12.339844 30.667969 12.351562 30.503906 C 12.125 30.523438 11.894531 30.535156 11.667969 30.535156 C 7.886719 30.535156 4.8125 27.460938 4.8125 23.683594 C 4.8125 20.695312 6.753906 18.078125 9.535156 17.171875 C 9.503906 16.90625 9.488281 16.640625 9.488281 16.367188 C 9.488281 12.847656 12.160156 9.9375 15.582031 9.558594 C 15.582031 9.527344 15.582031 9.492188 15.582031 9.460938 C 15.582031 5.683594 18.65625 2.609375 22.433594 2.609375 C 26.214844 2.609375 29.289062 5.683594 29.289062 9.460938 C 29.289062 9.648438 29.28125 9.832031 29.265625 10.015625 C 31.824219 11.046875 33.554688 13.558594 33.554688 16.371094 C 33.554688 16.527344 33.546875 16.6875 33.539062 16.84375 C 35.210938 18.140625 36.195312 20.128906 36.195312 22.261719 C 36.195312 24.40625 35.207031 26.398438 33.523438 27.691406 C 33.542969 27.914062 33.554688 28.132812 33.554688 28.355469 C 33.554688 32.136719 30.480469 35.210938 26.703125 35.210938 C 26.046875 35.210938 25.40625 35.117188 24.789062 34.9375 C 23.515625 36.75 21.429688 37.851562 19.183594 37.851562 Z M 13.402344 28.5625 C 13.621094 28.5625 13.835938 28.644531 14 28.804688 C 14.222656 29.023438 14.3125 29.34375 14.230469 29.648438 C 14.109375 30.082031 14.046875 30.539062 14.046875 31 C 14.046875 33.832031 16.351562 36.132812 19.183594 36.132812 C 21.050781 36.132812 22.773438 35.121094 23.679688 33.484375 C 23.890625 33.105469 24.355469 32.941406 24.757812 33.109375 C 25.371094 33.363281 26.027344 33.492188 26.703125 33.492188 C 29.535156 33.492188 31.839844 31.1875 31.839844 28.355469 C 31.839844 28.050781 31.808594 27.742188 31.757812 27.445312 C 31.695312 27.105469 31.84375 26.761719 32.132812 26.570312 C 33.601562 25.621094 34.480469 24.011719 34.480469 22.261719 C 34.480469 20.527344 33.613281 18.921875 32.160156 17.96875 C 31.882812 17.785156 31.734375 17.457031 31.78125 17.125 C 31.820312 16.875 31.839844 16.621094 31.839844 16.367188 C 31.839844 14.074219 30.296875 12.039062 28.089844 11.425781 C 27.65625 11.304688 27.390625 10.871094 27.476562 10.429688 C 27.539062 10.121094 27.570312 9.792969 27.570312 9.460938 C 27.570312 6.628906 25.265625 4.324219 22.433594 4.324219 C 19.601562 4.324219 17.300781 6.628906 17.300781 9.460938 C 17.300781 9.722656 17.320312 9.988281 17.359375 10.246094 C 17.402344 10.503906 17.320312 10.765625 17.144531 10.960938 C 16.96875 11.152344 16.710938 11.253906 16.453125 11.234375 C 16.414062 11.234375 16.375 11.234375 16.339844 11.234375 C 13.507812 11.234375 11.203125 13.539062 11.203125 16.371094 C 11.203125 16.789062 11.253906 17.199219 11.351562 17.589844 C 11.410156 17.820312 11.371094 18.0625 11.246094 18.261719 C 11.117188 18.460938 10.914062 18.597656 10.683594 18.644531 C 8.277344 19.109375 6.53125 21.226562 6.53125 23.683594 C 6.53125 26.515625 8.835938 28.820312 11.667969 28.820312 C 12.175781 28.820312 12.675781 28.746094 13.148438 28.597656 C 13.230469 28.574219 13.316406 28.5625 13.402344 28.5625 Z M 13.402344 28.5625 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
          <path
            fill="#ffffff"
            d="M 20.503906 48.1875 C 20.03125 48.1875 19.648438 47.800781 19.648438 47.328125 L 19.648438 17.988281 C 19.648438 17.515625 20.03125 17.132812 20.503906 17.132812 C 20.980469 17.132812 21.363281 17.515625 21.363281 17.988281 L 21.363281 47.328125 C 21.363281 47.800781 20.980469 48.1875 20.503906 48.1875 Z M 20.503906 48.1875 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 20.539062 25.457031 C 20.320312 25.457031 20.101562 25.375 19.933594 25.207031 C 19.597656 24.871094 19.597656 24.328125 19.933594 23.992188 L 24.378906 19.546875 C 24.714844 19.210938 25.257812 19.210938 25.59375 19.546875 C 25.925781 19.878906 25.925781 20.425781 25.59375 20.757812 L 21.144531 25.207031 C 20.976562 25.375 20.757812 25.457031 20.539062 25.457031 Z M 20.539062 25.457031 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 20.414062 30.191406 C 20.195312 30.191406 19.976562 30.105469 19.808594 29.9375 L 14.335938 24.46875 C 14 24.132812 14 23.589844 14.335938 23.253906 C 14.671875 22.917969 15.214844 22.917969 15.550781 23.253906 L 21.019531 28.726562 C 21.355469 29.058594 21.355469 29.601562 21.019531 29.9375 C 20.855469 30.105469 20.632812 30.191406 20.414062 30.191406 Z M 20.414062 30.191406 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 57.960938 41.09375 C 54.183594 41.09375 51.109375 38.019531 51.109375 34.242188 C 51.109375 34.078125 51.117188 33.910156 51.128906 33.746094 C 50.902344 33.769531 50.675781 33.78125 50.445312 33.78125 C 46.667969 33.78125 43.59375 30.707031 43.59375 26.929688 C 43.59375 23.9375 45.535156 21.320312 48.3125 20.414062 C 48.28125 20.152344 48.265625 19.882812 48.265625 19.613281 C 48.265625 16.089844 50.9375 13.179688 54.363281 12.804688 C 54.363281 12.769531 54.363281 12.738281 54.363281 12.707031 C 54.363281 8.925781 57.433594 5.851562 61.214844 5.851562 C 64.992188 5.851562 68.066406 8.925781 68.066406 12.707031 C 68.066406 12.890625 68.058594 13.074219 68.042969 13.257812 C 70.601562 14.289062 72.332031 16.804688 72.332031 19.613281 C 72.332031 19.769531 72.328125 19.929688 72.316406 20.089844 C 73.988281 21.382812 74.972656 23.371094 74.972656 25.507812 C 74.972656 27.652344 73.984375 29.644531 72.300781 30.9375 C 72.320312 31.15625 72.332031 31.378906 72.332031 31.601562 C 72.332031 35.378906 69.257812 38.453125 65.480469 38.453125 C 64.824219 38.453125 64.1875 38.363281 63.570312 38.183594 C 62.292969 39.996094 60.207031 41.09375 57.960938 41.09375 Z M 52.179688 31.804688 C 52.398438 31.804688 52.617188 31.890625 52.777344 32.046875 C 53.003906 32.265625 53.089844 32.589844 53.007812 32.890625 C 52.886719 33.328125 52.828125 33.78125 52.828125 34.242188 C 52.828125 37.074219 55.128906 39.378906 57.960938 39.378906 C 59.828125 39.378906 61.550781 38.363281 62.457031 36.730469 C 62.667969 36.347656 63.132812 36.1875 63.535156 36.351562 C 64.148438 36.609375 64.804688 36.738281 65.480469 36.738281 C 68.3125 36.738281 70.617188 34.433594 70.617188 31.601562 C 70.617188 31.292969 70.589844 30.988281 70.535156 30.691406 C 70.472656 30.351562 70.621094 30.003906 70.914062 29.816406 C 72.382812 28.867188 73.257812 27.253906 73.257812 25.507812 C 73.257812 23.773438 72.390625 22.167969 70.9375 21.210938 C 70.660156 21.027344 70.511719 20.699219 70.5625 20.371094 C 70.597656 20.121094 70.617188 19.863281 70.617188 19.613281 C 70.617188 17.316406 69.074219 15.285156 66.867188 14.667969 C 66.433594 14.550781 66.167969 14.117188 66.257812 13.675781 C 66.316406 13.363281 66.347656 13.039062 66.347656 12.707031 C 66.347656 9.875 64.046875 7.570312 61.214844 7.570312 C 58.382812 7.570312 56.078125 9.875 56.078125 12.707031 C 56.078125 12.96875 56.097656 13.234375 56.140625 13.492188 C 56.179688 13.75 56.101562 14.011719 55.921875 14.203125 C 55.746094 14.398438 55.492188 14.496094 55.230469 14.480469 C 55.191406 14.476562 55.15625 14.476562 55.117188 14.476562 C 52.285156 14.476562 49.984375 16.78125 49.984375 19.613281 C 49.984375 20.035156 50.03125 20.445312 50.132812 20.835938 C 50.1875 21.066406 50.148438 21.308594 50.023438 21.507812 C 49.894531 21.707031 49.691406 21.84375 49.460938 21.890625 C 47.054688 22.351562 45.308594 24.472656 45.308594 26.929688 C 45.308594 29.761719 47.613281 32.0625 50.445312 32.0625 C 50.953125 32.0625 51.453125 31.988281 51.929688 31.84375 C 52.011719 31.816406 52.097656 31.804688 52.179688 31.804688 Z M 52.179688 31.804688 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <g clipPath="url(#d39ab2ec3c)">
            <path
              fill="#ffffff"
              d="M 59.285156 61.953125 C 58.808594 61.953125 58.425781 61.566406 58.425781 61.09375 L 58.425781 21.234375 C 58.425781 20.761719 58.808594 20.375 59.285156 20.375 C 59.757812 20.375 60.140625 20.761719 60.140625 21.234375 L 60.140625 61.09375 C 60.140625 61.566406 59.757812 61.953125 59.285156 61.953125 Z M 59.285156 61.953125 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
          <path
            fill="#ffffff"
            d="M 59.316406 28.703125 C 59.097656 28.703125 58.878906 28.617188 58.710938 28.449219 C 58.375 28.113281 58.375 27.570312 58.710938 27.238281 L 63.15625 22.789062 C 63.492188 22.453125 64.035156 22.453125 64.371094 22.789062 C 64.707031 23.125 64.707031 23.667969 64.371094 24.003906 L 59.925781 28.449219 C 59.757812 28.617188 59.535156 28.703125 59.316406 28.703125 Z M 59.316406 28.703125 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <path
            fill="#ffffff"
            d="M 59.191406 33.433594 C 58.972656 33.433594 58.753906 33.351562 58.585938 33.183594 L 53.113281 27.710938 C 52.78125 27.375 52.78125 26.832031 53.113281 26.496094 C 53.449219 26.164062 53.992188 26.164062 54.328125 26.496094 L 59.800781 31.96875 C 60.136719 32.304688 60.136719 32.847656 59.800781 33.183594 C 59.632812 33.351562 59.414062 33.433594 59.191406 33.433594 Z M 59.191406 33.433594 "
            fillOpacity="1"
            fillRule="nonzero"
          />
          <g clipPath="url(#5944c24418)">
            <path
              fill="#ffffff"
              d="M 28.367188 61.953125 L 8.320312 61.953125 C 6.050781 61.953125 4.207031 60.105469 4.207031 57.839844 C 4.207031 56.378906 4.960938 55.054688 6.195312 54.316406 C 6.800781 53.097656 7.957031 52.265625 9.292969 52.074219 C 9.796875 50.753906 10.964844 49.777344 12.351562 49.507812 C 12.71875 47.613281 14.390625 46.175781 16.390625 46.175781 C 17.414062 46.175781 18.378906 46.550781 19.121094 47.214844 C 19.867188 46.550781 20.832031 46.175781 21.855469 46.175781 C 23.855469 46.175781 25.527344 47.613281 25.894531 49.503906 C 27.789062 49.871094 29.222656 51.542969 29.222656 53.542969 C 29.222656 53.632812 29.222656 53.726562 29.214844 53.816406 C 31.078125 54.207031 32.476562 55.863281 32.476562 57.839844 C 32.476562 60.105469 30.632812 61.953125 28.367188 61.953125 Z M 9.890625 53.75 L 9.878906 53.75 C 8.898438 53.75 8.023438 54.339844 7.65625 55.25 C 7.578125 55.445312 7.433594 55.605469 7.246094 55.699219 C 6.429688 56.105469 5.921875 56.925781 5.921875 57.839844 C 5.921875 59.160156 6.996094 60.234375 8.316406 60.234375 L 28.367188 60.234375 C 29.6875 60.234375 30.761719 59.160156 30.761719 57.839844 C 30.761719 56.519531 29.6875 55.441406 28.367188 55.441406 C 28.320312 55.441406 28.277344 55.445312 28.230469 55.445312 C 27.949219 55.460938 27.675781 55.332031 27.503906 55.101562 C 27.335938 54.875 27.289062 54.578125 27.382812 54.308594 C 27.464844 54.066406 27.507812 53.808594 27.507812 53.542969 C 27.507812 52.222656 26.433594 51.148438 25.109375 51.148438 C 24.636719 51.148438 24.253906 50.761719 24.253906 50.289062 C 24.253906 48.96875 23.179688 47.894531 21.855469 47.894531 C 21.039062 47.894531 20.289062 48.304688 19.84375 48.988281 C 19.6875 49.234375 19.414062 49.382812 19.121094 49.382812 C 18.832031 49.382812 18.558594 49.234375 18.402344 48.988281 C 17.957031 48.304688 17.207031 47.894531 16.390625 47.894531 C 15.066406 47.894531 13.992188 48.96875 13.992188 50.289062 C 13.992188 50.761719 13.609375 51.148438 13.136719 51.148438 C 12 51.148438 11.011719 51.953125 10.785156 53.0625 C 10.703125 53.484375 10.320312 53.777344 9.890625 53.75 Z M 9.890625 53.75 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
          <g clipPath="url(#3d728003be)">
            <path
              fill="#ffffff"
              d="M 51.390625 61.953125 L 25.625 61.953125 C 25.148438 61.953125 24.765625 61.566406 24.765625 61.09375 C 24.765625 60.621094 25.148438 60.234375 25.625 60.234375 L 51.390625 60.234375 C 53.226562 60.234375 54.71875 58.742188 54.71875 56.910156 C 54.71875 55.078125 53.226562 53.585938 51.390625 53.585938 C 51.332031 53.585938 51.265625 53.585938 51.203125 53.589844 C 50.921875 53.601562 50.648438 53.472656 50.480469 53.242188 C 50.3125 53.015625 50.265625 52.71875 50.359375 52.449219 C 50.476562 52.117188 50.535156 51.761719 50.535156 51.386719 C 50.535156 49.554688 49.042969 48.0625 47.210938 48.0625 C 46.734375 48.0625 46.351562 47.679688 46.351562 47.207031 C 46.351562 45.371094 44.859375 43.878906 43.027344 43.878906 C 41.894531 43.878906 40.847656 44.449219 40.234375 45.402344 C 40.074219 45.648438 39.804688 45.792969 39.511719 45.792969 C 39.222656 45.792969 38.949219 45.648438 38.792969 45.402344 C 38.175781 44.449219 37.132812 43.878906 35.996094 43.878906 C 34.164062 43.878906 32.671875 45.371094 32.671875 47.207031 C 32.671875 47.679688 32.289062 48.0625 31.816406 48.0625 C 30.238281 48.0625 28.867188 49.183594 28.554688 50.722656 C 28.472656 51.140625 28.09375 51.433594 27.667969 51.410156 C 27.65625 51.410156 27.644531 51.410156 27.632812 51.410156 C 27.363281 51.410156 27.097656 51.441406 26.847656 51.503906 C 26.386719 51.617188 25.921875 51.332031 25.808594 50.875 C 25.695312 50.414062 25.980469 49.949219 26.441406 49.835938 C 26.640625 49.789062 26.847656 49.75 27.054688 49.726562 C 27.664062 47.984375 29.199219 46.703125 31.019531 46.410156 C 31.402344 44.007812 33.488281 42.164062 35.996094 42.164062 C 37.332031 42.164062 38.582031 42.683594 39.511719 43.589844 C 40.441406 42.683594 41.695312 42.164062 43.027344 42.164062 C 45.535156 42.164062 47.621094 44.007812 48.003906 46.410156 C 50.40625 46.792969 52.25 48.878906 52.25 51.386719 C 52.25 51.574219 52.242188 51.757812 52.222656 51.9375 C 54.609375 52.335938 56.433594 54.414062 56.433594 56.910156 C 56.433594 59.691406 54.171875 61.953125 51.390625 61.953125 Z M 51.390625 61.953125 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
          <g clipPath="url(#aa839afb10)">
            <path
              fill="#ffffff"
              d="M 66.082031 61.953125 L 0.882812 61.953125 C 0.410156 61.953125 0.0273438 61.566406 0.0273438 61.09375 C 0.0273438 60.621094 0.410156 60.234375 0.882812 60.234375 L 66.082031 60.234375 C 66.554688 60.234375 66.9375 60.621094 66.9375 61.09375 C 66.9375 61.566406 66.554688 61.953125 66.082031 61.953125 Z M 66.082031 61.953125 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
          <g clipPath="url(#66e2abaf46)">
            <g clipPath="url(#648f915682)">
              <path
                fill="#ffffff"
                d="M 27.523438 53.296875 L 29.398438 53.296875 L 29.398438 55.207031 L 27.523438 55.207031 Z M 27.523438 53.296875 "
                fillOpacity="1"
                fillRule="nonzero"
              />
            </g>
          </g>
        </svg>
      );
    case BRAND_AMEX:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <rect fill="#016fd0" height="16" rx="2" width="24" />
            <path
              d="M13.764 13.3939V7.6925l10.1476.009v1.575l-1.1729 1.2534 1.1729 1.2648v1.6083H22.039l-.9952-1.0981-.9881 1.1023z"
              fill="#fffffe"
            />
            <path
              d="M14.4418 12.7688V8.3199h3.7723v1.0249h-2.5509v.6957h2.49v1.0078h-2.49v.6833h2.5509v1.0372z"
              fill="#016fd0"
            />
            <path
              d="M18.1953 12.7688l2.0873-2.227L18.1952 8.32h1.6156l1.2755 1.41 1.2791-1.41h1.5462v.035l-2.0429 2.1868 2.0429 2.1639v.0631h-1.5617l-1.2981-1.4242-1.2848 1.4242z"
              fill="#016fd0"
            />
            <path
              d="M14.2373 2.632h2.4461l.8591 1.9508V2.632h3.0199l.5207 1.4615.5226-1.4615h2.3059v5.7013H11.7251z"
              fill="#fffffe"
            />
            <g fill="#016fd0">
              <path d="M14.7005 3.2514l-1.974 4.4451h1.3539l.3724-.8901h2.018l.372.8901h1.3877l-1.9658-4.4451zm.1696 2.5574l.592-1.415.5916 1.415z" />
              <path d="M18.212 7.6957v-4.445l1.903.0065.9794 2.7327.9856-2.7392h1.8316v4.445l-1.1786.0105V4.6528l-1.1126 3.043h-1.0758L19.409 4.6423v3.0533z" />
            </g>
          </g>
        </svg>
      );
    case FAVLIKE:
      return (
        <svg
          fill="#000000"
          width="800px"
          height="800px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#00ac9d"
            d="M22,9.67A1,1,0,0,0,21.14,9l-5.69-.83L12.9,3a1,1,0,0,0-1.8,0L8.55,8.16,2.86,9a1,1,0,0,0-.81.68,1,1,0,0,0,.25,1l4.13,4-1,5.68a1,1,0,0,0,.4,1,1,1,0,0,0,1.05.07L12,18.76l5.1,2.68a.93.93,0,0,0,.46.12,1,1,0,0,0,.59-.19,1,1,0,0,0,.4-1l-1-5.68,4.13-4A1,1,0,0,0,22,9.67Zm-6.15,4a1,1,0,0,0-.29.89l.72,4.19-3.76-2a1,1,0,0,0-.94,0l-3.76,2,.72-4.19a1,1,0,0,0-.29-.89l-3-3,4.21-.61a1,1,0,0,0,.76-.55L12,5.7l1.88,3.82a1,1,0,0,0,.76.55l4.21.61Z"
          />
        </svg>
      );
    case COPY:
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 0.6 0.6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.05 0.1a0.05 0.05 0 0 1 0.05 -0.05h0.25a0.05 0.05 0 0 1 0.05 0.05v0.1h0.1a0.05 0.05 0 0 1 0.05 0.05v0.25a0.05 0.05 0 0 1 -0.05 0.05H0.25a0.05 0.05 0 0 1 -0.05 -0.05v-0.1H0.1a0.05 0.05 0 0 1 -0.05 -0.05V0.1zm0.2 0.3v0.1h0.25V0.25h-0.1v0.1a0.05 0.05 0 0 1 -0.05 0.05h-0.1zm0.1 -0.05V0.1H0.1v0.25h0.25z"
            fill="#0D0D0D"
          />
        </svg>
      );
    case WHATSAPP:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 2.4 2.4"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.527 1.321a0.701 0.701 0 0 1 0.154 0.07l-0.003 -0.002c0.053 0.024 0.099 0.051 0.14 0.083l-0.002 -0.001c0.002 0.006 0.003 0.013 0.003 0.02l0 0.003v0c-0.002 0.043 -0.011 0.083 -0.027 0.12l0.001 -0.002c-0.023 0.046 -0.062 0.082 -0.109 0.101l-0.001 0.001a0.362 0.362 0 0 1 -0.158 0.041h-0.001a0.834 0.834 0 0 1 -0.299 -0.098l0.004 0.002a0.89 0.89 0 0 1 -0.264 -0.183l0 0a2.047 2.047 0 0 1 -0.225 -0.279l-0.005 -0.007a0.538 0.538 0 0 1 -0.11 -0.3l0 -0.001v-0.012a0.342 0.342 0 0 1 0.114 -0.245l0 0a0.117 0.117 0 0 1 0.081 -0.034h0c0.01 0 0.02 0.001 0.029 0.003l-0.001 0c0.009 0.001 0.019 0.002 0.029 0.002h0a0.064 0.064 0 0 1 0.041 0.01l0 0c0.011 0.012 0.019 0.026 0.024 0.042l0 0.001q0.012 0.031 0.051 0.136c0.014 0.031 0.027 0.07 0.037 0.11l0.001 0.006a0.157 0.157 0 0 1 -0.053 0.089l0 0q-0.054 0.057 -0.054 0.072a0.044 0.044 0 0 0 0.008 0.023l0 0a0.703 0.703 0 0 0 0.158 0.212l0.001 0.001a0.989 0.989 0 0 0 0.228 0.154l0.006 0.003a0.068 0.068 0 0 0 0.034 0.011h0q0.023 0 0.084 -0.075t0.08 -0.075zm-0.315 0.822h0.002a0.944 0.944 0 0 0 0.381 -0.08l-0.006 0.002c0.236 -0.099 0.419 -0.283 0.516 -0.512l0.002 -0.006c0.049 -0.111 0.078 -0.241 0.078 -0.378s-0.028 -0.266 -0.08 -0.384l0.002 0.006c-0.099 -0.236 -0.283 -0.419 -0.512 -0.516l-0.006 -0.002c-0.111 -0.049 -0.241 -0.078 -0.378 -0.078s-0.266 0.028 -0.384 0.08l0.006 -0.002c-0.236 0.099 -0.419 0.283 -0.516 0.512l-0.002 0.006a0.948 0.948 0 0 0 -0.078 0.379 0.96 0.96 0 0 0 0.188 0.572l-0.002 -0.003 -0.123 0.361 0.375 -0.119a0.945 0.945 0 0 0 0.53 0.161h0.005zm0 -2.143h0.003c0.163 0 0.318 0.034 0.458 0.096L1.666 0.093c0.283 0.12 0.503 0.34 0.62 0.615l0.003 0.008c0.059 0.134 0.093 0.29 0.093 0.454s-0.034 0.32 -0.096 0.461l0.003 -0.007c-0.12 0.283 -0.34 0.503 -0.615 0.62l-0.008 0.003c-0.133 0.059 -0.288 0.093 -0.45 0.093h-0.003c-0.206 0 -0.399 -0.054 -0.566 -0.149l0.006 0.003L0 2.4l0.211 -0.628a1.151 1.151 0 0 1 -0.167 -0.601c0 -0.165 0.034 -0.321 0.096 -0.463l-0.003 0.007C0.256 0.433 0.476 0.213 0.751 0.096L0.759 0.093A1.118 1.118 0 0 1 1.209 0h0.003z" />
        </svg>
      );
    case SHARE:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 12.8 12.8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>share</title>
          <path d="M9.625 11.6q-0.7 0 -1.15 -0.475 -0.475 -0.475 -0.475 -1.15 0 -0.225 0.025 -0.275l-3.75 -2.125q-0.425 0.425 -1.05 0.425 -0.675 0 -1.15 -0.475t-0.475 -1.15q0 -0.65 0.475 -1.1 0.475 -0.475 1.15 -0.475 0.625 0 1.05 0.425l3.75 -2.1q-0.025 -0.075 -0.025 -0.35 0 -0.65 0.475 -1.1 0.45 -0.475 1.125 -0.475 0.65 0 1.125 0.475 0.45 0.45 0.475 1.1 0 0.675 -0.475 1.15t-1.125 0.475q-0.575 0 -1.075 -0.425l-3.75 2.125q0.025 0.05 0.025 0.275 0 0.25 -0.025 0.325l3.75 2.125q0.5 -0.425 1.1 -0.425 0.75 0 1.15 0.475t0.4 1.125q0 0.65 -0.4 1.125t-1.15 0.475Z" />
        </svg>
      );
    case FILLHEART:
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 0.375 0.375"
          version="1.1"
          id="heart"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#00ac9d"
            d="M0.348 0.169c-0.029 0.056 -0.107 0.133 -0.152 0.174a0.013 0.013 0 0 1 -0.017 0C0.135 0.302 0.056 0.225 0.027 0.169 -0.037 0.045 0.125 -0.038 0.188 0.086c0.063 -0.124 0.225 -0.041 0.16 0.083z"
          />
        </svg>
      );
    case BLANKHEART:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M17.017 3.817a4.5 4.5 0 0 0 -6.375 0l-0.642 0.65 -0.642 -0.65a4.5 4.5 0 0 0 -6.375 0C1.217 5.583 1.108 8.567 3.333 10.833l6.667 6.667 6.667 -6.667c2.225 -2.267 2.117 -5.25 0.35 -7.017z"
            fill="none"
          />
        </svg>
      );
    case CARDSTAR:
      return (
        <svg
          _ngcontent-gkw-c154=""
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className="element selected"
        >
          <path
            _ngcontent-gkw-c154=""
            d="M7.89744 0.0385742L9.67052 5.88535H15.4083L10.7663 9.49886L12.5394 15.3456L7.89744 11.7321L3.25544 15.3456L5.02852 9.49886L0.386528 5.88535H6.12435L7.89744 0.0385742Z"
            fill="#FFC165"
          ></path>
        </svg>
      );
    case LOCATIONCARD:
      return (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="512.000000pt"
          height="512.000000pt"
          viewBox="0 0 512.000000 512.000000"
          preserveAspectRatio="xMidYMid meet"
          className="s-ion-icon"
        >
          {' '}
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
            {' '}
            <path d="M2289 5105 c-672 -105 -1225 -571 -1438 -1211 -75 -224 -86 -296 -85 -574 0 -217 2 -257 22 -350 33 -149 95 -332 156 -452 28 -57 285 -465 571 -908 285 -443 635 -986 778 -1208 143 -221 263 -402 267 -402 15 0 1564 2414 1616 2518 61 120 123 303 156 452 20 93 22 133 22 350 1 278 -10 350 -85 574 -214 644 -770 1109 -1447 1211 -121 18 -414 18 -533 0z m476 -306 c316 -41 616 -192 851 -428 210 -212 345 -462 410 -761 26 -119 27 -458 1 -575 -30 -137 -78 -275 -136 -387 -51 -97 -1319 -2077 -1331 -2077 -12 0 -1280 1980 -1331 2077 -58 112 -106 250 -136 387 -26 117 -25 456 1 575 100 460 393 841 801 1045 277 138 559 184 870 144z"></path>{' '}
            <path d="M2365 4205 c-332 -73 -595 -329 -681 -663 -23 -88 -25 -110 -21 -247 6 -168 18 -226 77 -351 116 -250 330 -429 595 -500 98 -26 361 -27 455 0 309 85 560 335 645 641 26 93 31 312 11 416 -71 350 -348 631 -695 704 -89 18 -301 18 -386 0z m375 -321 c187 -59 346 -228 395 -419 19 -76 19 -214 0 -288 -27 -104 -75 -187 -155 -268 -119 -121 -255 -179 -420 -179 -165 0 -301 58 -420 179 -117 119 -170 247 -170 411 0 154 49 283 152 394 165 181 388 242 618 170z"></path>{' '}
          </g>{' '}
        </svg>
      );
    case BLANKSTAR:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="#e6e6e6"
          className="element"
        >
          <path
            fill="#e6e6e6"
            d="M7.89744 0.0385742L9.67052 5.88535H15.4083L10.7663 9.49886L12.5394 15.3456L7.89744 11.7321L3.25544 15.3456L5.02852 9.49886L0.386528 5.88535H6.12435L7.89744 0.0385742Z"
          ></path>
        </svg>
      );
    case PEOPLES:
      return (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="500.000000pt"
          height="500.000000pt"
          viewBox="0 0 500 500"
          preserveAspectRatio="xMidYMid meet"
          className="s-ion-icon"
        >
          <g transform="matrix(.1 0 0 -.1 0 512)" stroke="none">
            <path d="M2309.575 4260.75c-306.65 -65.425 -538.075 -316.4 -582.025 -633.8 -33.2 -240.225 72.275 -504.875 264.65 -664.075 64.45 -52.725 206.05 -125 292.975 -147.45 87.9 -23.45 292.975 -23.45 379.875 0.975 256.825 70.325 466.8 279.3 533.2 528.325 82.025 313.475 -56.65 658.2 -331.05 824.225 -162.1 97.65 -371.1 131.825 -557.625 91.8zm317.375 -174.8c194.325 -54.7 354.5 -218.75 405.275 -414.075 22.45 -85.95 16.6 -236.325 -12.7 -316.4 -84.95 -234.375 -301.75 -388.675 -543.95 -387.7 -167.975 0 -290.05 51.75 -410.15 171.875 -151.375 151.375 -204.1 342.775 -150.4 543.95 82.025 302.725 409.175 487.3 711.925 402.35z" />
            <path d="M3852.55 3751.95c-205.075 -61.525 -363.275 -225.575 -410.15 -423.825 -61.525 -260.75 69.325 -536.125 307.625 -650.4 98.625 -46.875 159.175 -60.55 267.575 -60.55 258.8 0 484.375 171.875 558.6 424.8 22.45 78.125 22.45 224.6 0 301.75 -54.7 185.55 -193.35 333.975 -368.175 396.475 -87.9 30.275 -271.475 37.1 -355.475 11.725zm253.9 -163.075c78.125 -20.5 141.6 -56.65 198.25 -114.25 160.15 -161.125 156.25 -412.1 -8.8 -569.325 -167 -160.15 -414.075 -158.2 -576.175 3.9 -98.625 99.6 -139.65 229.5 -112.3 361.325 47.85 230.475 276.375 375.975 499.025 318.35z" />
            <path d="M839.85 3714.85c-203.125 -54.7 -355.475 -204.1 -416.025 -409.175 -22.45 -78.125 -22.45 -224.6 0 -302.725 53.7 -183.6 194.325 -333.975 370.125 -395.5 84.95 -30.275 251.95 -37.1 337.9 -14.65 208.975 54.7 377.925 223.625 425.775 426.75 18.55 79.1 18.55 191.4 0 270.5 -47.85 202.15 -224.6 377.925 -426.75 425.775 -78.125 18.55 -220.7 17.575 -291.025 -0.975zm244.15 -166.025c161.125 -36.125 283.2 -167.975 312.5 -336.925 44.925 -259.775 -209.95 -508.8 -471.675 -459.95 -276.375 51.75 -426.75 340.825 -303.7 583.975 51.75 101.575 176.75 196.3 289.075 217.775 64.45 12.7 100.575 11.725 173.825 -4.875z" />
            <path d="M2299.8 2694.325c-157.225 -23.45 -337.9 -85.95 -478.525 -166.025 -90.825 -51.75 -222.65 -150.4 -271.475 -202.15l-28.325 -29.3 -83.975 42.975c-46.875 23.45 -124.025 54.7 -172.85 69.325 -82.025 24.425 -99.6 26.375 -273.45 26.375 -174.8 0 -190.425 -0.975 -273.45 -26.375 -340.825 -104.5 -582.025 -342.775 -685.55 -676.75C5.825 1646.45 5.825 1641.575 4.85 1380.825V1116.175l27.35 -39.075c14.65 -21.475 48.825 -50.775 74.225 -65.425l47.85 -25.4h978.525l4.875 -27.35c15.625 -73.25 27.35 -100.575 64.45 -142.575 22.45 -25.4 58.6 -55.675 81.05 -67.375l40.05 -21.475h2353.525l40.05 21.475c46.875 25.4 107.425 89.85 126.95 134.775 6.825 17.575 15.625 60.55 19.525 96.675l6.825 64.45h482.425c525.4 0 522.45 0 582.025 56.65 15.625 14.65 37.1 42.975 47.85 64.45 18.55 35.15 18.55 52.725 15.625 288.075 -3.9 238.275 -5.85 253.9 -31.25 337.9 -51.75 170.9 -125.975 295.9 -251.95 421.875 -292 295.9 -749.025 375.975 -1127.925 198.25 -44.925 -20.5 -93.75 -46.875 -109.375 -58.6l-29.3 -19.525 -85.95 68.35c-195.325 157.225 -432.625 260.75 -669.925 292 -89.85 12.7 -308.6 11.725 -392.575 0zm328.125 -165.05c193.35 -22.45 390.625 -95.7 552.725 -207.025 197.275 -133.8 372.075 -365.225 447.275 -587.9 50.775 -150.4 55.675 -190.425 60.55 -485.35 4.875 -304.7 4.875 -308.6 -48.825 -340.825 -30.275 -18.55 -59.575 -19.525 -1139.65 -19.525s-1109.375 0.975 -1139.65 19.525c-53.7 32.225 -53.7 36.125 -48.825 340.825 4.875 294.925 9.775 334.95 60.55 485.35 172.85 515.625 712.9 857.425 1255.85 794.925zm1534.175 -208.975c269.525 -51.75 509.775 -246.1 609.375 -492.2 47.85 -120.125 54.7 -163.075 59.575 -378.9l4.875 -206.05 -22.45 -16.6c-20.5 -13.675 -73.25 -15.625 -483.4 -15.625h-459.95l-6.825 144.525c-14.65 317.375 -80.075 531.25 -233.4 756.825l-64.45 94.725 65.425 33.2c177.725 87.9 351.575 114.25 531.25 80.075zM1195.3 2246.075c42.975 -10.75 107.425 -33.2 143.55 -49.8l65.425 -30.275 -53.7 -82.025c-95.7 -147.45 -162.1 -318.35 -192.375 -492.2 -8.8 -50.775 -18.55 -170.9 -22.45 -265.625l-5.85 -173.825H664.075c-450.2 0 -466.8 0.975 -483.4 19.525 -15.625 16.6 -16.6 37.1 -11.725 221.675 3.9 167.975 7.825 214.85 25.4 273.45 91.8 313.475 331.05 532.225 650.4 594.725 90.825 17.575 250.975 10.75 350.575 -15.625z" />
          </g>
        </svg>
      );
    case STAR:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 0.6 0.6"
          id="star"
          dataName="Flat Color"
          xmlns="http://www.w3.org/2000/svg"
          className="icon flat-color"
        >
          <path
            id="primary"
            d="M0.55 0.245a0.025 0.025 0 0 0 -0.021 -0.017l-0.143 -0.02 -0.065 -0.12a0.025 0.025 0 0 0 -0.044 0L0.214 0.209l-0.143 0.02a0.025 0.025 0 0 0 -0.021 0.017 0.025 0.025 0 0 0 0.007 0.025l0.102 0.093 -0.025 0.131a0.025 0.025 0 0 0 0.036 0.028L0.3 0.46l0.128 0.063a0.025 0.025 0 0 0 0.011 0.003 0.025 0.025 0 0 0 0.025 -0.029l-0.025 -0.131 0.102 -0.093A0.025 0.025 0 0 0 0.55 0.245Z"
            fill="#00ac9d"
          />
        </svg>
      );
    case PEOPLE:
      return (
        <svg
          fill="#000000"
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 1.3 1.3"
          enableBackground="new 0 0 52 52"
        >
          <g>
            <path d="M1.05 0.557c-0.07 -0.028 -0.08 -0.055 -0.08 -0.083s0.02 -0.055 0.045 -0.075c0.043 -0.035 0.065 -0.088 0.065 -0.145 0 -0.11 -0.072 -0.205 -0.2 -0.205 -0.118 0 -0.188 0.08 -0.198 0.177 0 0.01 0.005 0.017 0.013 0.023 0.095 0.06 0.152 0.165 0.152 0.292 0 0.095 -0.038 0.18 -0.105 0.24 -0.005 0.005 -0.005 0.015 0 0.02 0.017 0.013 0.057 0.03 0.083 0.043 0.007 0.003 0.013 0.005 0.02 0.005h0.302c0.057 0 0.102 -0.048 0.102 -0.1v-0.015c0 -0.088 -0.095 -0.135 -0.2 -0.177z" />
            <path d="M0.715 0.905c-0.085 -0.035 -0.098 -0.065 -0.098 -0.098 0 -0.033 0.025 -0.065 0.053 -0.09 0.05 -0.043 0.078 -0.102 0.078 -0.173 0 -0.13 -0.085 -0.242 -0.24 -0.242 -0.152 0 -0.24 0.113 -0.24 0.242 0 0.07 0.028 0.13 0.078 0.173 0.028 0.025 0.053 0.057 0.053 0.09 0 0.033 -0.013 0.065 -0.1 0.098 -0.125 0.05 -0.248 0.107 -0.248 0.213V1.15c0 0.055 0.045 0.1 0.102 0.1h0.693c0.057 0 0.105 -0.045 0.105 -0.1v-0.035c0 -0.102 -0.11 -0.16 -0.235 -0.21z" />
          </g>
        </svg>
      );
    case ROUNDCHECK:
      return (
        <svg
          width="50px"
          height="50px"
          viewBox="0 0 2 2"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="icomoon-ignore" />
          <path
            d="M1 0.167C0.54 0.167 0.167 0.54 0.167 1S0.54 1.833 1 1.833c0.46 0 0.833 -0.373 0.833 -0.833S1.46 0.167 1 0.167zm0 1.599C0.577 1.766 0.234 1.423 0.234 1S0.577 0.234 1 0.234c0.423 0 0.766 0.344 0.766 0.766S1.423 1.766 1 1.766z"
            fill="#4a4a4f"
          />
          <path
            d="m1.417 0.703 -0.535 0.519 -0.187 -0.187a0.05 0.05 0 0 0 -0.071 0.071l0.222 0.222a0.05 0.05 0 0 0 0.07 0.001l0.57 -0.553a0.05 0.05 0 0 0 -0.07 -0.072z"
            fill="#4a4a4f"
          />
        </svg>
      );
    case MESSAGE:
      return (
        <svg
          version="1.1"
          id="MESSAGE"
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          height="50px"
          viewBox="0 0 112.5 112.5"
          enableBackground="new 0 0 1800 1800"
        >
          <g>
            <g>
              <path
                fill="#4a4a4f"
                d="M15.718 103.875a1.957 1.957 0 0 1 -0.979 -0.262 1.958 1.958 0 0 1 -0.979 -1.696v-12.597H5.429c-2.773 0 -5.029 -2.256 -5.029 -5.029V23.78c0 -2.773 2.256 -5.029 5.029 -5.029h91.709c2.773 0 5.03 2.256 5.03 5.029v60.511c0 2.773 -2.256 5.029 -5.03 5.029H41.453l-24.757 14.293a1.956 1.956 0 0 1 -0.979 0.262zM5.429 22.667c-0.614 0 -1.114 0.499 -1.114 1.113v60.511c0 0.614 0.5 1.113 1.114 1.113h10.288c1.081 0 1.958 0.876 1.958 1.958v11.164l22.274 -12.86a1.958 1.958 0 0 1 0.979 -0.262h56.209c0.614 0 1.114 -0.499 1.114 -1.113V23.78c0 -0.614 -0.5 -1.113 -1.114 -1.113H5.429z"
              />
            </g>
            <g>
              <path
                fill="#4a4a4f"
                d="M59.549 37.974H15.835c-1.081 0 -1.958 -0.876 -1.958 -1.958 0 -1.081 0.876 -1.958 1.958 -1.958h43.714c1.081 0 1.958 0.876 1.958 1.958 0 1.081 -0.876 1.958 -1.958 1.958z"
              />
            </g>
            <g>
              <path
                fill="#4a4a4f"
                d="M86.733 49.663H15.835c-1.081 0 -1.958 -0.876 -1.958 -1.958 0 -1.081 0.876 -1.958 1.958 -1.958h70.897c1.081 0 1.958 0.876 1.958 1.958 0 1.081 -0.876 1.958 -1.958 1.958z"
              />
            </g>
            <g>
              <path
                fill="#4a4a4f"
                d="M86.733 61.351H15.835c-1.081 0 -1.958 -0.876 -1.958 -1.958 0 -1.081 0.876 -1.958 1.958 -1.958h70.897c1.081 0 1.958 0.876 1.958 1.958 0 1.081 -0.876 1.958 -1.958 1.958z"
              />
            </g>
            <g>
              <path
                fill="#4a4a4f"
                d="M86.733 73.039H15.835c-1.081 0 -1.958 -0.876 -1.958 -1.958 0 -1.081 0.876 -1.958 1.958 -1.958h70.897c1.081 0 1.958 0.876 1.958 1.958 0 1.081 -0.876 1.958 -1.958 1.958z"
              />
            </g>
            <g>
              <path
                fill="#4a4a4f"
                d="M107.008 9.063H15.299c-2.773 0 -5.029 2.256 -5.029 5.029v5.342h3.916v-5.342c0 -0.614 0.5 -1.113 1.114 -1.113h91.709c0.614 0 1.114 0.5 1.114 1.113v60.511c0 0.614 -0.5 1.113 -1.114 1.113h-6.798v3.916h6.798c2.773 0 5.029 -2.256 5.029 -5.029v-60.511c0 -2.773 -2.256 -5.029 -5.029 -5.029z"
              />
            </g>
          </g>
        </svg>
      );
    case MAIL:
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          height="50px"
          viewBox="0 0 4 4"
          enableBackground="new 0 0 64 64"
        >
          <g>
            <path
              x="1"
              y="13"
              fill="none"
              stroke="#4a4a4f"
              strokeWidth="0.125"
              strokeMiterlimit="10"
              width="62"
              height="37"
              d="M0.063 0.813H3.938V3.125H0.063V0.813z"
            />
            <path
              fill="none"
              stroke="#4a4a4f"
              strokeWidth="0.125"
              strokeMiterlimit="10"
              points="1,13 32,33 63,13 	"
              d="M0.063 0.813L2 2.063L3.938 0.813"
            />
          </g>
        </svg>
      );
    case CANCEL:
      return (
        <svg
          fill="#000000"
          width="30px"
          height="30px"
          viewBox="0 0 1.35 1.35"
          version="1.1"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="clr-i-outline clr-i-outline-path-1"
            d="M0.675 0.075a0.6 0.6 0 1 0 0.6 0.6A0.6 0.6 0 0 0 0.675 0.075ZM0.15 0.675a0.522 0.522 0 0 1 0.129 -0.343l0.739 0.739A0.525 0.525 0 0 1 0.15 0.675Zm0.921 0.343L0.332 0.279a0.525 0.525 0 0 1 0.739 0.739Z"
          />
          <path x="0" y="0" width="36" height="36" fillOpacity="0" d="M0 0H1.35V1.35H0V0z" />
        </svg>
      );
    case LOCATION:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 0.6 0.6"
          version="1.2"
          baseProfile="tiny"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.441 0.133c-0.078 -0.077 -0.205 -0.077 -0.283 0a0.195 0.195 0 0 0 0 0.278L0.3 0.55l0.141 -0.139a0.195 0.195 0 0 0 0 -0.278zM0.3 0.337c-0.017 0 -0.032 -0.007 -0.044 -0.018a0.063 0.063 0 0 1 0 -0.088c0.012 -0.012 0.028 -0.018 0.044 -0.018s0.032 0.007 0.044 0.018a0.063 0.063 0 0 1 0 0.088c-0.012 0.012 -0.028 0.018 -0.044 0.018z" />
        </svg>
      );
    case USER:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 0.9 0.9"
          version="1.1"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.45 0.425a0.175 0.175 0 1 0 -0.175 -0.175 0.175 0.175 0 0 0 0.175 0.175Zm0 -0.3a0.125 0.125 0 1 1 -0.125 0.125 0.125 0.125 0 0 1 0.125 -0.125Z"
            className="clr-i-outline clr-i-outline-path-1"
          />
          <path
            d="M0.762 0.609a0.429 0.429 0 0 0 -0.623 0A0.05 0.05 0 0 0 0.125 0.643V0.775a0.05 0.05 0 0 0 0.05 0.05h0.55a0.05 0.05 0 0 0 0.05 -0.05v-0.132a0.05 0.05 0 0 0 -0.013 -0.034ZM0.725 0.775H0.175v-0.132a0.379 0.379 0 0 1 0.55 0Z"
            className="clr-i-outline clr-i-outline-path-2"
          />
          <path x="0" y="0" width="36" height="36" fillOpacity="0" d="M0 0H0.9V0.9H0V0z" />
        </svg>
      );
    case PLUS:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 0.6 0.6"
          id="plus"
          data-name="Flat Color"
          xmlns="http://www.w3.org/2000/svg"
          className="icon flat-color"
        >
          <path
            id="primary"
            d="M0.3 0.5A0.025 0.025 0 0 1 0.275 0.475V0.325H0.125a0.025 0.025 0 0 1 0 -0.05h0.15V0.125a0.025 0.025 0 0 1 0.05 0v0.15h0.15a0.025 0.025 0 0 1 0 0.05H0.325v0.15A0.025 0.025 0 0 1 0.301 0.5Z"
          />
        </svg>
      );
    case TRASH:
      return (
        <svg
          width="40px"
          height="40px"
          viewBox="0 0 1.2 1.2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.35 0.2a0.1 0.1 0 0 1 0.1 -0.1h0.3a0.1 0.1 0 0 1 0.1 0.1v0.1h0.2a0.05 0.05 0 1 1 0 0.1h-0.053l-0.043 0.607A0.1 0.1 0 0 1 0.853 1.1H0.347a0.1 0.1 0 0 1 -0.1 -0.093L0.204 0.4H0.15a0.05 0.05 0 0 1 0 -0.1h0.2V0.2zm0.1 0.1h0.3V0.2H0.45v0.1zM0.304 0.4l0.043 0.6H0.854l0.043 -0.6H0.304zM0.5 0.5a0.05 0.05 0 0 1 0.05 0.05v0.3a0.05 0.05 0 1 1 -0.1 0v-0.3a0.05 0.05 0 0 1 0.05 -0.05zm0.2 0a0.05 0.05 0 0 1 0.05 0.05v0.3a0.05 0.05 0 1 1 -0.1 0v-0.3a0.05 0.05 0 0 1 0.05 -0.05z"
            fill="#0D0D0D"
          />
        </svg>
      );
    case SEARCH:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="-0.063 -0.063 0.6 0.6"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMinYMin"
          className="jam jam-search"
        >
          <path
            d="M0.2 0.35A0.15 0.15 0 1 0 0.2 0.05a0.15 0.15 0 0 0 0 0.3zm0.158 -0.027 0.09 0.09a0.025 0.025 0 1 1 -0.035 0.035l-0.09 -0.09a0.2 0.2 0 1 1 0.035 -0.035z"
            fill="#696969"
          />
        </svg>
      );
    case CROSS:
      return (
        <svg
          fill="grey"
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          id="cross-circle"
          className="icon glyph"
        >
          <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm3.71,12.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.42,9.71,15.71a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.58,12,8.29,9.71A1,1,0,0,1,9.71,8.29L12,10.58l2.29-2.29a1,1,0,0,1,1.42,1.42L13.42,12Z"></path>
        </svg>
      );
    case CLOCK:
      return (
        <svg
          fill="#5d5d5d"
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c-.02-6.619-5.381-11.98-11.998-12zm0 21.6c-5.302 0-9.6-4.298-9.6-9.6s4.298-9.6 9.6-9.6 9.6 4.298 9.6 9.6c-.016 5.296-4.304 9.584-9.598 9.6zm.6-15.6h-1.8v7.2l6.24 3.84.96-1.56-5.4-3.24z" />
        </svg>
      );
    case HALFSTAR:
      return (
        <svg width="20px" height="20px" viewBox="0 -1.111 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 0c-0.396 0 -0.792 0.205 -0.997 0.618L6.736 5.215 1.663 5.951c-0.91 0.132 -1.274 1.253 -0.615 1.896l3.67 3.576 -0.868 5.052c-0.156 0.906 0.799 1.597 1.611 1.17L10 15.264z" />
        </svg>
      );
    case BRAND_DINERS:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M21.9972 15.75h.0022c.955.0081 1.7387-.7727 1.7506-1.7458V2.0063c-.0038-.4706-.1911-.9201-.5203-1.2495a1.7197 1.7197 0 0 0-1.2325-.5067H2.0006C1.5411.246 1.0986.4283.7703.7568.441 1.0862.2538 1.5357.25 2.0043v11.9894c.0038.4706.1911.9201.5203 1.2495a1.7197 1.7197 0 0 0 1.2325.5067h19.9944zm-.001.5h-.0011.0021-.001z"
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
            />
            <path
              d="M10.0021 2.0518v-.016h4v.016c3.1354.2294 5.5621 2.8402 5.5621 5.984s-2.4267 5.7546-5.562 5.984v.016h-4v-.016C6.8666 13.7904 4.44 11.1796 4.44 8.0358s2.4267-5.7546 5.5621-5.984z"
              fill="#0165AC"
            />
            <path
              d="M11.6021 11.4278a3.6 3.6 0 0 0 0-6.784v6.784zm-2.4-6.784a3.6 3.6 0 0 0 0 6.784v-6.784zm1.2 8.592c-2.8719 0-5.2-2.3281-5.2-5.2s2.3281-5.2 5.2-5.2 5.2 2.3281 5.2 5.2-2.3281 5.2-5.2 5.2z"
              fill="#FFF"
            />
          </g>
        </svg>
      );
    case BRAND_DISCOVERY:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M21.9972 15.75h.0022c.955.0081 1.7387-.7727 1.7506-1.7458V2.0063c-.0038-.4706-.1911-.9201-.5203-1.2495a1.7197 1.7197 0 0 0-1.2325-.5067H2.0006C1.5411.246 1.0986.4283.7703.7568.441 1.0862.2538 1.5357.25 2.0043v11.9894c.0038.4706.1911.9201.5203 1.2495a1.7197 1.7197 0 0 0 1.2325.5067h19.9944zm-.001.5h-.0011.0021-.001z"
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
            />
            <path
              d="M12.6124 16h9.3848A1.9862 1.9862 0 0 0 24 14.0302v-2.3586a38.7393 38.7393 0 0 1-11.3876 4.3282z"
              fill="#F27712"
            />
            <path
              d="M23.1724 9.2965H22.32l-.96-1.2662h-.091v1.2662h-.6952V6.1517H21.6c.8028 0 1.2662.331 1.2662.9268 0 .4883-.2896.8028-.811.9021l1.1172 1.3159zm-1.0262-2.1931c0-.3062-.2317-.4635-.662-.4635h-.2152v.9518h.1986c.4469 0 .6786-.1656.6786-.4883zm-4.0055-.9517h1.9696v.5296H18.836v.7035h1.2248v.5379h-1.2248v.8524h1.2744v.5297h-1.9696V6.1517zm-2.2345 3.2275L14.4 6.1434h.7614l.9517 2.1186.96-2.1186h.7448l-1.5227 3.2358h-.389zm-6.298-.0082c-1.0592 0-1.8868-.72-1.8868-1.6552 0-.9104.8441-1.647 1.9034-1.647.298 0 .5462.058.8524.1904v.7283a1.2414 1.2414 0 0 0-.869-.3558c-.662 0-1.1668.48-1.1668 1.084 0 .6373.4965 1.0925 1.2 1.0925.3145 0 .5545-.0993.8358-.3476v.7283c-.3144.1324-.5793.182-.869.182zm-2.102-1.0345c0 .6124-.5048 1.0345-1.2331 1.0345-.5297 0-.9103-.1821-1.2331-.5959l.4552-.389c.1572.2814.422.4221.753.4221.3146 0 .538-.1903.538-.4386 0-.1407-.0662-.2483-.2069-.331a2.88 2.88 0 0 0-.48-.1821c-.6538-.207-.8772-.4304-.8772-.869 0-.513.48-.902 1.109-.902.3972 0 .753.124 1.051.3558l-.3642.4138a.7614.7614 0 0 0-.5627-.2483c-.298 0-.5131.149-.5131.3476 0 .1655.1241.2566.5379.3973.7945.2482 1.0262.48 1.0262.993v-.0082zm-3.418-2.1848h.6952v3.153h-.6951v-3.153zm-2.2344 3.153H.8276v-3.153h1.0262c1.1255 0 1.9034.6455 1.9034 1.5724 0 .4717-.2317.9186-.6372 1.2165-.3476.2483-.7366.3642-1.2745.3642h.0083zm.811-2.3668c-.2317-.1821-.4965-.2483-.9517-.2483h-.1903V8.775h.1903c.4469 0 .7283-.0828.9517-.2483.24-.1986.3807-.4965.3807-.8027 0-.3062-.1407-.5959-.3807-.7862z"
              fill="#000"
            />
            <path
              d="M12.4138 6.0689c-.9104 0-1.6552.7283-1.6552 1.6303 0 .96.7117 1.68 1.6552 1.68.9269 0 1.6552-.7282 1.6552-1.6551 0-.927-.72-1.6552-1.6552-1.6552z"
              fill="#F27712"
            />
          </g>
        </svg>
      );
    case BRAND_JCB:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 23 16"
          width="23"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M.2054 16h4.5178c1.0278 0 2.259-1.1947 2.259-2.1333V0h-4.518C1.4366 0 .2055 1.1947.2055 3.2z"
              fill="#047ab1"
            />
            <path
              d="M2.7692 10.816a9.7709 9.7709 0 0 1-2.5638-.3413V9.3013c.6467.3777 1.386.5909 2.146.6187.8696 0 1.3553-.576 1.3553-1.3653V5.3333h2.146v3.2214c0 1.2586-.7003 2.2613-3.0835 2.2613z"
              fill="#fff"
            />
            <path
              d="M8.1116 16h4.5179c1.0278 0 2.2589-1.1947 2.2589-2.1333V0h-4.5179C9.3427 0 8.1116 1.1947 8.1116 3.2z"
              fill="#d42d06"
            />
            <path
              d="M8.1116 6.08c.6551-.5973 1.7846-.9707 3.6143-.8853.994.0426 2.033.32 2.033.32v1.184c-.5943-.3395-1.2623-.5474-1.954-.608C10.4158 5.9733 9.5687 6.7093 9.5687 8s.8471 2.0267 2.2364 1.92c.692-.066 1.3596-.2774 1.954-.6187v1.1734s-1.0392.288-2.0331.3306c-1.8297.0854-2.9592-.288-3.6143-.8853z"
              fill="#fff"
            />
            <path
              d="M16.0179 16h4.5178c1.0278 0 2.259-1.1947 2.259-2.1333V0h-4.518C17.249 0 16.018 1.1947 16.018 3.2z"
              fill="#67b637"
            />
            <path
              d="M21.6652 9.28c0 .8533-.7003 1.3867-1.6377 1.3867h-4.0096V5.3333h3.6481l.2598.0107c.8245.0427 1.4344.5013 1.4344 1.2907 0 .6186-.4179 1.152-1.1746 1.28v.032c.8358.0533 1.4796.5546 1.4796 1.3333zM18.785 6.176a1.0871 1.0871 0 0 0-.1468-.0107H17.283v1.344h1.5021c.2824-.064.5196-.3093.5196-.672 0-.3626-.2372-.608-.5196-.6613zm.1695 2.176a1.0276 1.0276 0 0 0-.1808-.0107H17.283v1.4614h1.4908l.1808-.0214c.2823-.064.5195-.3413.5195-.7146 0-.3734-.2259-.64-.5195-.7147z"
              fill="#fff"
            />
          </g>
        </svg>
      );
    case BRAND_MASTERCARD:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <rect fill="#252525" height="16" rx="2" width="24" />
            <circle cx="9" cy="8" fill="#eb001b" r="5" />
            <circle cx="15" cy="8" fill="#f79e1b" r="5" />
            <path
              d="M12 3.9996c1.2144.9122 2 2.3646 2 4.0004s-.7856 3.0882-2 4.0004C10.7856 11.0882 10 9.6358 10 8s.7856-3.0882 2-4.0004z"
              fill="#ff5f00"
            />
          </g>
        </svg>
      );
    case BRAND_UNIONPAY:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M4.5459 0h5.7938c.8087 0 1.3117.7257 1.123 1.619L8.7655 14.3675c-.1904.8902-1.0002 1.6165-1.8095 1.6165H1.1627c-.8076 0-1.3118-.7263-1.1231-1.6165L2.7381 1.619C2.9268.7257 3.7361 0 4.546 0"
              fill="#dd2423"
            />
            <path
              d="M9.8576 0h6.6627c.8086 0 .444.7257.2537 1.619l-2.697 12.7485c-.1892.8902-.1302 1.6165-.9405 1.6165H6.4738c-.8103 0-1.3118-.7263-1.1214-1.6165L8.0493 1.619C8.2408.7257 9.0483 0 9.8576 0"
              fill="#16315e"
            />
            <path
              d="M16.256 0h5.7938c.8098 0 1.3129.7257 1.1226 1.619l-2.697 12.7485c-.1903.8902-1.0006 1.6165-1.8104 1.6165h-5.791c-.8104 0-1.313-.7263-1.1232-1.6165L14.4482 1.619C14.637.7257 15.4457 0 16.256 0"
              fill="#036862"
            />
            <path
              d="M6.059 4.0856c-.5958.0067-.7717 0-.828-.0146-.0216.113-.4236 2.1546-.4247 2.1563-.0866.413-.1496.7075-.3635.8976-.1215.1105-.2633.1639-.4276.1639-.2643 0-.4182-.1445-.444-.4184l-.005-.094s.0805-.5533.0805-.5564c0 0 .422-1.8605.4975-2.1064a.1945.1945 0 0 0 .0061-.028c-.8213.008-.967 0-.977-.0146-.0055.02-.0258.1354-.0258.1354l-.4308 2.097-.037.1778-.0716.5817c0 .1725.0307.3134.092.4325.1963.3776.7563.4342 1.073.4342.4081 0 .791-.0955 1.0497-.2698.449-.292.5666-.7486.6713-1.1544l.0486-.2081s.4347-1.9323.5085-2.1837c.0029-.014.004-.0213.0078-.028zm1.479 1.5588c-.1048 0-.2963.028-.4683.1208-.0624.0353-.1215.076-.1838.1166l.0562-.2234-.0307-.0376c-.3648.0813-.4464.0922-.7834.1444l-.0282.0207c-.0391.357-.0739.6255-.219 1.3274a90.3116 90.3116 0 0 1-.17.778l.0156.0327c.3453-.02.45-.02.7502-.0146l.0242-.029c.0382-.215.0431-.2654.1276-.7009.0396-.2064.1224-.66.1632-.8215.075-.0383.149-.0759.2196-.0759.1682 0 .1477.1615.1412.2259-.0072.108-.0685.4609-.1313.7639l-.042.1955c-.0292.1445-.0612.2848-.0905.428l.0127.0286c.3404-.02.4442-.02.7348-.0146l.0342-.029c.0525-.3358.0679-.4257.1611-.9146l.0469-.2246c.091-.4397.1368-.6626.068-.8442-.073-.2035-.2478-.2526-.4083-.2526zm1.6521.4603c-.181.0383-.2963.0637-.411.0802-.1136.02-.2245.0383-.3993.065l-.0139.0138-.0127.011c-.0182.1434-.0309.2673-.055.413-.0205.1506-.052.3218-.1033.5677-.0397.1882-.0601.2538-.0827.32-.022.0663-.0463.1307-.091.3158l.0105.0171.0087.0157c.1634-.0085.2703-.0146.3802-.0157.1097-.0043.2234 0 .3994.001l.0154-.0137.0165-.0153c.0254-.167.0292-.2119.0447-.2933.0154-.0874.042-.2083.107-.5314.0309-.1517.0652-.303.0971-.4578.0332-.1542.068-.306.101-.4578l-.005-.0183zm.0039-.6206c-.1644-.1068-.453-.0729-.6471.0746-.1936.1446-.2157.3498-.0518.458.1615.1038.4512.0729.6436-.0759.1932-.1477.2174-.351.0553-.4567zm.994 2.4734c.3326 0 .6735-.101.9301-.4003.1974-.2428.288-.6041.3193-.7529.1021-.4931.0226-.7233-.0772-.8635-.1517-.2138-.4197-.2824-.6978-.2824-.1672 0-.5654.0182-.8765.334-.2234.2277-.3267.5368-.389.833-.0628.302-.135.8454.319 1.0477.14.0662.342.0844.4722.0844zm-.026-1.1095c.0768-.3734.1673-.6868.3983-.6868.181 0 .1942.2332.1137.6078-.0144.0832-.0805.3924-.1699.524-.0624.0972-.1363.1561-.2179.1561-.0243 0-.1688 0-.171-.2361-.0011-.1166.0205-.2357.0469-.365zm2.1068 1.0615l.026-.0291c.0368-.215.0429-.2655.1245-.7008.0408-.2065.1253-.66.165-.8216.075-.0384.1478-.076.2207-.076.167 0 .1467.1615.14.2259-.006.1082-.0673.4609-.1313.7639l-.0396.1955c-.0304.1446-.0635.2848-.0927.4282l.0127.0286c.3415-.02.4413-.02.7337-.0146l.0353-.0291c.0512-.336.065-.4258.161-.9146l.0458-.2247c.0916-.4397.1379-.6624.07-.844-.0749-.2035-.2509-.2526-.4092-.2526-.1049 0-.2974.0278-.4684.1208a3.0577 3.0577 0 0 0-.1826.1166l.0524-.2234-.028-.0378c-.3647.0814-.448.0923-.7846.1446l-.0258.0206c-.0408.3571-.074.6254-.219 1.3275a95.9633 95.9633 0 0 1-.17.7779l.0155.0328c.3458-.02.449-.02.7486-.0146zm2.5088.0145c.0215-.1154.149-.799.1501-.799 0 0 .1086-.5017.1152-.5199 0 0 .0342-.0522.0684-.0729h.0503c.4743 0 1.01 0 1.4298-.34.2857-.2332.481-.5775.5681-.996a1.6492 1.6492 0 0 0 .0393-.3466c0-.1603-.0292-.3189-.1137-.4428-.214-.3297-.6404-.3358-1.1326-.3383l-.2426.0025c-.63.0086-.8826.0061-.9864-.0079-.0088.0505-.0253.1404-.0253.1404s-.2256 1.1513-.2256 1.1531l-.5655 2.5632c.55-.0073.7756-.0073.8705.0042zm.4181-2.0452s.24-1.149.2388-1.1446l.0078-.059.0034-.0448.0959.0108s.4948.0468.5064.048c.1953.0832.2758.2976.2196.5774-.0513.2558-.202.4708-.3956.5746-.1594.088-.3547.0953-.556.0953h-.1301zm1.494.9905c-.0635.2975-.1364.841.3154 1.0347.144.0674.2731.0875.4043.0802.1385-.0082.2669-.0847.3858-.1948l-.0322.1359.0205.029c.325-.015.4258-.015.7778-.012l.032-.0268c.0513-.3327.0998-.6557.2334-1.2922.065-.3048.13-.6067.1968-.9103l-.0104-.0334c-.3635.0741-.4607.09-.8103.1445l-.0266.0238c-.0035.031-.0072.0607-.0106.0904-.0543-.0967-.1331-.1793-.2547-.2307-.1555-.0674-.5207.0194-.8346.334-.2206.2247-.3265.5325-.3867.8277zm.7633.0182c.0778-.3668.1672-.677.3988-.677.1465 0 .2236.1487.208.4024-.0125.0633-.026.13-.0419.2054-.0232.109-.0483.217-.0727.3252-.0249.074-.0538.1438-.0856.1903-.0596.093-.2014.1506-.283.1506-.0232 0-.166 0-.171-.232-.0011-.1154.0205-.2344.0474-.365zm3.9867-1.2109l-.0281-.0353c-.3597.0802-.4248.093-.7552.1421l-.0243.0267c-.0012.0044-.0021.011-.0038.0171l-.0012-.006c-.246.6248-.2388.49-.439.9818-.0011-.0224-.0011-.0363-.0023-.0601l-.0501-1.0663-.0315-.0353c-.3768.0802-.3857.093-.7336.1421l-.0271.0267c-.0039.0128-.0039.0268-.0061.042l.0022.0055c.0435.2446.033.19.0767.5762.0204.1895.0475.3801.0678.5673.0343.3132.0535.4674.0955.9455-.235.4268-.2907.5884-.5169.963l.0016.0037-.1593.2774c-.0182.0292-.0348.0492-.058.0578-.0253.0138-.0584.0163-.1043.0163h-.0882l-.1312.4804.45.0085c.2642-.0012.4303-.1372.5197-.32l.283-.5339h-.0045l.0298-.0376c.1904-.4511 1.6384-3.1856 1.6384-3.1856zm-4.7501 6.3088h-.191l.7067-2.573h.2344l.0745-.265.0072.2947c-.0088.1822.1214.3437.4634.317h.3956l.1361-.4954h-.1488c-.0856 0-.1253-.0238-.1203-.0748l-.0072-.2999h-.7325v.0016c-.2369.0054-.944.025-1.0873.067-.1732.049-.3558.1937-.3558.1937l.0717-.2654h-.6852l-.1428.5265-.716 2.6123h-.139l-.1363.4919h1.3647l-.0457.164h.6724l.0447-.164h.1886zm-.56-2.0502c-.1097.0334-.3139.1348-.3139.1348l.1816-.6576h.5444l-.1313.4791s-.1682.011-.2807.0437zm.0105.9394s-.171.0237-.2836.0516c-.1108.037-.3187.1536-.3187.1536l.1876-.6843h.5472zm-.305 1.1168h-.5461l.1583-.5775h.5444zm1.315-1.5959h.7872l-.113.4033h-.7977l-.1197.4408h.6979l-.5285.8191c-.037.0602-.0702.0815-.107.0984-.037.0207-.0856.045-.1418.045h-.1936l-.133.4828h.5064c.2632 0 .4187-.1318.5335-.3048l.3624-.546.0778.5544c.0165.1038.0843.1646.1302.1882.0507.028.103.076.177.0832.0794.0037.1368.0067.1749.0067h.2488l.1494-.5404h-.0981c-.0564 0-.1534-.0104-.1699-.0298-.0165-.0237-.0165-.06-.0254-.1154l-.079-.5556h-.3232l.1418-.1858h.796l.1225-.4408h-.737l.1148-.4033h.7347l.1363-.4973h-2.1906zm-6.6482 1.7082l.1837-.6728h.7551l.138-.5004h-.7558l.1153-.4141h.7386l.1369-.4846h-1.848l-.134.4846h.4198l-.112.414h-.421l-.1395.509h.4197l-.2449.8902c-.033.1178.0156.1627.0464.2175.0315.0533.0634.0886.1351.1086.074.0182.1247.0291.1936.0291h.8513l.1517-.5544-.3774.0571c-.0729 0-.2747-.0096-.2526-.0838zm.0866-3.2208l-.1914.3807c-.041.0831-.0778.1348-.111.1585-.0292.02-.0871.0285-.171.0285h-.0998l-.1335.487h.3316c.1594 0 .2819-.0643.3403-.0965.0629-.037.0794-.0159.128-.0675l.112-.1068h1.0354l.1374-.507h-.758l.1324-.277zm1.5286 3.2306c-.0177-.028-.005-.0773.022-.1799l.283-1.0311h1.0068c.1467-.0023.2526-.0042.3215-.0096.074-.0086.1545-.0377.2422-.0899.0905-.0547.1369-.1124.176-.1786.0436-.066.1137-.2107.1738-.4336l.3557-1.3049-1.0447.0067s-.3217.0522-.4633.11c-.143.0643-.3471.244-.3471.244l.0943-.3577h-.6454l-.9035 3.2986c-.032.128-.0535.221-.0585.2769-.0017.0601.069.1197.1147.1646.054.0449.134.0376.2107.0449.0806.0067.1953.0109.3536.0109h.496l.1522-.5659-.444.0462a.1138.1138 0 0 1-.096-.0516zm.4876-1.9074h1.0575l-.0673.2319c-.0094.0054-.032-.0115-.1396.0025h-.9157zm.2118-.778h1.0664l-.0767.2794s-.5026-.0054-.583.0109c-.3543.0675-.5611.2758-.5611.2758zm.8021 1.7866c-.0087.0347-.0226.0558-.042.0717-.0214.0152-.0561.0206-.108.0206h-.1506l.0089-.2824H12.7l-.0254 1.3809c-.001.0996.0078.1573.074.2035.0662.0576.2703.065.545.065h.3927l.1418-.517-.342.0207-.1136.0073c-.0155-.0073-.0304-.014-.0469-.0321-.0144-.0157-.0387-.0061-.0347-.1057l.0027-.354.3585-.0163c.1936 0 .2764-.0694.347-.1354.0674-.0633.0894-.136.1148-.2345l.0602-.3134h-.4927z"
              fill="#fefefe"
            />
          </g>
        </svg>
      );
    case BRAND_VISA:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fillRule="nonzero" fill="none">
            <rect
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
              x=".25"
              y=".25"
              width="23.5"
              height="15.5"
              rx="2"
            />
            <path
              d="M2.78773262 5.91443732C2.26459089 5.62750595 1.6675389 5.39673777 1 5.23659312l.0280005-.12471102h2.73697872c.37098332.01300346.67201191.12462375.76996714.51882925l.59482061 2.83587917.18221641.85413565L6.97796639 5.1118821h1.79882257l-2.67390785 6.1656463H4.30396552l-1.5162329-5.36309108zm7.31224258 5.36963648H8.39882877l1.06401886-6.1721917H11.163901l-1.0639258 6.1721917zm6.1668069-6.02129922l-.2313529 1.3328108-.1538632-.06554092c-.3078194-.12479829-.7141522-.2495093-1.2671852-.2363313-.6716398 0-.9728545.26905813-.9798314.53174543 0 .28895604.3643786.47938251.9593659.76179318.9801104.43993579 1.4347231.97831385 1.4279323 1.68093694-.0137677 1.28044789-1.1758348 2.10786929-2.9607967 2.10786929-.7631763-.0066327-1.4982591-.1579615-1.8972429-.3284901l.2380507-1.38552277.224004.09861682c.5530331.23004776.9169465.32831555 1.5961213.32831555.4897761 0 1.0149017-.19060107 1.0215995-.60409358 0-.26923267-.2237249-.46637906-.8818761-.76842582-.6439184-.29558867-1.5048639-.78797464-1.4909101-1.67447884C11.8780532 5.84042483 13.0610509 5 14.7409877 5c.6580581 0 1.1902536.13788902 1.5257944.26277458zm2.2609703 3.83471102h1.4139786c-.0699548-.30859213-.3921-1.78601186-.3921-1.78601186l-.1188858-.5318327c-.0840015.22978594-.2308878.60409353-.2238179.59091553 0 0-.5390794 1.3723448-.6791749 1.72692903zm2.0998512-3.9856035L22 11.2839865h-1.5750977s-.1541422-.7091684-.2029803-.9258637h-2.1841317c-.0631639.1640705-.3570296.9258637-.3570296.9258637h-1.7849619l2.5268355-5.65999506c.1750729-.40057632.4833574-.51210934.889132-.51210934h1.3158373z"
              fill="#171E6C"
            />
          </g>
        </svg>
      );
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

IconCard.defaultProps = {
  className: null,
  rootClassName: null,
  brand: 'default',
};

IconCard.propTypes = {
  className: string,
  rootClassName: string,
  brand: string,
};

export default IconCard;
